import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LotService } from '../../../shared/inventory/service/lot.service';
import { HttpResponse } from '@angular/common/http';
import { JhiLanguageService } from '../../../shared/core-utils';
import { Lot } from '../../../shared/inventory/model/lot.model';
import { finalize } from 'rxjs/operators';
import { AlertService } from '../../../shared/alert/alert.service';

@Component({
    selector: 'jhi-lot',
    templateUrl: './lot.component.html',
})
export class LotComponent implements OnInit {

    readonly itemsPerPage: number = 10;

    lots: Lot[];

    gid: number;
    page: number;
    previousPage: number;
    totalItems: number;
    queryCount: number;
    predicate: string;
    reverse: boolean;

    isLoading: boolean;

    constructor(private activatedRoute: ActivatedRoute,
                private lotService: LotService,
                private alertService: AlertService,
                private jhiLanguageService: JhiLanguageService,
                private router: Router,
    ) {
        const queryParams = this.activatedRoute.snapshot.queryParams;
        this.gid = queryParams.gid;
        this.page = 1;
        this.predicate = 'lotId';
        this.reverse = false;
    }

    ngOnInit(): void {
        this.loadAll();
    }

    private loadAll() {
        this.isLoading = true;
        this.lotService.getLotsByGId(this.gid, {
            status: 'ACTIVE',
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).pipe(finalize(() => {
            this.isLoading = false;
        })).subscribe(
            (res: HttpResponse<Lot[]>) => this.onSuccess(res.body, res.headers)
        );
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        this.router.navigate(['./'], {
            queryParams:
                {
                    page: this.page,
                    size: this.itemsPerPage,
                    sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                },
            relativeTo: this.activatedRoute,
            queryParamsHandling: 'merge'
        });
        this.loadAll();
    }

    sort() {
        const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'lotId') {
            result.push('lotId');
        }
        return result;
    }

    private onSuccess(data: Lot[], headers) {
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        this.lots = data;
    }

    trackId(item: Lot) {
        return item.lotId;
    }

}
